/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { Flex, Heading, Button } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { _DEFAULT_SITE_REPRESENTATIVE } from "../constants";
import FormInput from "../../../components/forms/form-Input";

export default function SiteRepresentative({
  addData,
  onNextStep,
  onPrevStep,
  siteRepresentatives,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);

  const {
    handleSubmit,
    getValues,
    watch,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ..._DEFAULT_SITE_REPRESENTATIVE,
      siteRepresentatives: [...siteRepresentatives],
    },
  });
  const generalFieldProps = { control, errors };

  const formValidationRules = {
    name: { required: "Please enter name" },
    employeeId: { required: "Please enter employee id" },
    email: {
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid Email(abc@gmail.com)",
      },
    },
  };

  const {
    fields: siteRepresentativeFields,
    remove: siteRepresentativeFieldsRemove,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "siteRepresentatives",
  });

  useEffect(() => {
    if (addData) {
      addData([...siteRepresentativeFields]);
    }
  }, [watch("siteRepresentatives")]);

  const submitInfo = (data) => {
    const _siteRepresentative = [...siteRepresentativeFields];
    const newRepresentative = {
      name: data.name,
      employeeId: data.employeeId,
      mobileNo: data.mobileNo,
      email: data.email,
    };
    if (currentEditing !== null) {
      _siteRepresentative[currentEditing] = newRepresentative;
      setCurrentEditing(null);
    } else {
      _siteRepresentative.push(newRepresentative);
    }
    reset({
      ..._DEFAULT_SITE_REPRESENTATIVE,
      siteRepresentatives: [..._siteRepresentative],
    });
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            reset({
              ...getValues(),
              ...dataItem,
              siteRepresentatives: [...siteRepresentativeFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete"
          cursor="pointer"
          onClick={() => {
            siteRepresentativeFieldsRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const cancelEditing = () => {
    reset({
      ..._DEFAULT_SITE_REPRESENTATIVE,
      siteRepresentatives: [...siteRepresentativeFields],
    });
    setCurrentEditing(null);
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Flex direction="column">
          <Heading style={{ width: "100%", whiteSpace: "nowrap" }}>
            Site Representative
          </Heading>
        </Flex>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex w="100%" justify="flex-end" flexDirection="row" gap="16px">
            <Button
              type="button"
              onClick={() => onPrevStep(siteRepresentativeFields)}
            >
              Back
            </Button>
            <Button
              type="button"
              onClick={() => onNextStep(siteRepresentativeFields)}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Name"
        name="name"
        rules={formValidationRules.name}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Employee ID"
        name="employeeId"
        rules={formValidationRules.employeeId}
      />
      <FormInput
        {...generalFieldProps}
        label="Mobile No"
        name="mobileNo"
        rules={formValidationRules.mobileNo}
      />
      <FormInput
        {...generalFieldProps}
        label="Email"
        name="email"
        rules={formValidationRules.email}
        info="abc@xyz.com"
      />
      <div style={{ width: "100%" }} />
      <Grid data={siteRepresentativeFields} style={{ width: "100%" }}>
        <GridColumn title="Name" field="name" />
        <GridColumn title="Employee ID" field="employeeId" />
        <GridColumn title="Mobile No" field="mobileNo" />
        <GridColumn title="Email" field="email" />
        <GridColumn title="Edit" cell={editCell} width={120} />
        <GridColumn title="Delete" cell={deleteCell} width={120} />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button onClick={cancelEditing}>Cancel</Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null
            ? "Update Representative"
            : "Add Representative"}
        </Button>
      </div>
    </form>
  );
}
